import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-bootstrap-modal'
import NewTeam from './forms/new-team'
import EditTeam from './forms/edit-team'

const Teams = (props) => {
  const [modalMode, setModalMode] = useState(false)
  const [newTeam, setNewTeam] = useState(false)
  const [editTeam, setEditTeam] = useState(null)
  const [formChanged, setFormChanged] = useState(false)
  const nextForm = useRef()
  const formRef = useRef()
  const { league, teams } = props
  const preventAddingTeam = teams.length >= league.teams_count
  const currencyName = league.currency == 'usd' ? '' : ` (${league.currency.toUpperCase()})`

  useEffect(() => {
    setModalMode(window.innerWidth < 1400)
    window.addEventListener('resize', handleResize)
  }, [])

  const handleResize = () => {
    setModalMode(window.innerWidth < 1400)
  }

  const imageUrl = (team) => {
    if (!team.photo) return '/images/leagues/team.png'

    return team.photo + '?' + Math.random()
  }

  const switchTeam = (team) => {
    props.onShorten(!!team)
    setEditTeam(team)
    setFormChanged(false)
    nextForm.current = null
  }
  
  const onEditTeam = (team) => {
    if (!formChanged) return switchTeam(team)

    if (window.confirm('There are unsaved changes. Do you want to save them before continue?')) {
      formRef.current.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))
      nextForm.current = team
    }
  }

  const onAddTeam = (team) => {
    setNewTeam(false)
    props.onAddTeam(team)
  }

  const onDeleteTeam = (id) => {
    props.onDeleteTeam(id)
    switchTeam(null)
  }

  const onUpdateTeam = (team) => {
    props.onUpdateTeam(team)
    nextForm.current ? switchTeam(nextForm.current) : switchTeam(null)
  }

  const teamRowClass = (team) => {
    if (editTeam && team.id == editTeam.id) return 'selected'

    return ''
  }

  const teamsTable = () => {
    return <table className='teams-table'>
      <thead>
        <tr>
          <th>TEAM</th>
          <th>CAPTAIN PHONE</th>
          <th>TEAM STATUS</th>
          <th>TOTAL GAMES</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {teamsList()}
      </tbody>
    </table>
  }

  const teamsList = () => {
    return teams.map((team, i) => {
      return <tr className={teamRowClass(team)} key={i} onClick={() => onEditTeam(team)}>
        <td>
          <div className='team-title'>
            <img src={imageUrl(team)} />
            <span>{team.name}</span>
          </div>
        </td>
        <td>{team.phone}</td>
        <td><span className='team-owe'>{`Owe${currencyName} $${parseFloat(team.balance).toFixed(2)}`}</span></td>
        <td>0</td>
        <td><button className='team-edit-button'></button></td>
      </tr>
    })
  }

  return <div className='league-teams-wrapper'>
    <div id='league-teams'>
      <button 
        className='league-add-team'
        onClick={() => setNewTeam(true)}
        disabled={preventAddingTeam}
        title={preventAddingTeam ? 'This League has reached the limit of teams allowed' : 'Create New Team'}
      >
        Create New Team
      </button>
      <div className={'teams-table-wrap' + (props.shortened ? ' shortened' : '')}>
        {teamsTable()}
      </div>
    </div>
    { newTeam && 
      <NewTeam
        league={league}
        locationName={props.locationName}
        onClose={() => setNewTeam(false)}
        onCreate={onAddTeam}
      />
    }
    { editTeam && !modalMode &&
      <div className='edit-team-wrapper'>
        <EditTeam
          id={editTeam.id}
          league={league}
          balance={editTeam.balance}
          onClose={() => switchTeam(null)}
          formRef={formRef}
          onUpdate={onUpdateTeam}
          onDelete={onDeleteTeam}
          onChanged={value => setFormChanged(value)}
        />
      </div>
    }
    { editTeam && modalMode &&
      <Modal show={true} container={document.body} backdrop='static' dialogClassName='edit-team-modal' onHide={() => onEditTeam(null)}>
        <Modal.Header closeButton>
          <Modal.Title>Team Info</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditTeam
            id={editTeam.id}
            league={league}
            balance={editTeam.balance}
            onClose={() => switchTeam(null)}
            formRef={formRef}
            onUpdate={onUpdateTeam}
            onDelete={onDeleteTeam}
            onChanged={value => setFormChanged(value)}
          />
        </Modal.Body>
      </Modal>
    }
  </div>
}

Teams.propTypes = {
  teams: PropTypes.array.isRequired,
  league: PropTypes.object.isRequired,
  locationName: PropTypes.string.isRequired,
  shortened: PropTypes.bool,
  onAddTeam: PropTypes.func.isRequired,
  onDeleteTeam: PropTypes.func.isRequired,
  onUpdateTeam: PropTypes.func.isRequired,
  onShorten: PropTypes.func.isRequired,
}

export default Teams
